/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { LabelCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const CareerProgression = ({
    goalSummary,
    stepsToAchieve,
    careerProgressionPromotion,
    promotionYear,
    promotionLevel,
    promotionContact,
}: Partial<{
    goalSummary: string;
    stepsToAchieve?: string;
    careerProgressionPromotion: boolean;
    promotionYear: string;
    promotionLevel: string;
    promotionContact: string;
}>) => (
    <>
        <Row>
            <ValueCell label="Goal Summary" value={goalSummary} />
        </Row>
        {stepsToAchieve && (
            <Row>
                <ValueCell label="Steps to achieve this goal" value={stepsToAchieve} />
            </Row>
        )}
        {careerProgressionPromotion && (
            <>
                <Row>
                    <LabelCell label="I am planning for promotion within the next three years" />
                </Row>
                {promotionYear && (
                    <Row>
                        <ValueCell label="Year of intended application" value={promotionYear} />
                    </Row>
                )}
                {promotionLevel && (
                    <Row>
                        <ValueCell label="Level of intended application" value={promotionLevel} />
                    </Row>
                )}
                {promotionContact && (
                    <Row>
                        <ValueCell
                            label="Would you like to be contacted by the Promotions Team"
                            value={promotionContact}
                        />
                    </Row>
                )}
            </>
        )}
    </>
);

export default CareerProgression;
